module.exports = "<img [src]=\"imageURL\" name=\"das\" />\n"